module.exports = __webpack_public_path__ + "static/media/bd5.36d70bc9.jpg";